module.exports = __webpack_public_path__ + "img/submitidea-img.de06a964.png";